module.exports = __webpack_public_path__ + "img/Menu-19.ffad0619.webp";